<template>
    <div :class="ChartType === 'Selected' || ChartType === 'HighSelectable'  ? 'Selection' : null" v-if="DisplayItems.length > 0">
        <div :class="ChartType === 'RecommendSelectable' && UserSelection.recommendProviderReference !== null && UserSelection.recommendProviderReference !== '' && UserSelection.recommendProviderReference === dataItem.Reference ? 'card Selection' : 'card'" style="margin-bottom:10px;" v-for="(dataItem) in DisplayItems" :key="dataItem.Reference">
            <div @click="ChartType !== 'RecommendSelectable' ? Select(dataItem.Reference) : RecommandSelect(dataItem.Reference)" style="display:flex;justify-content: space-between;">
                <el-image v-if="ChartType === 'RecommendSelectable'" style="width:30px; margin-right:10px;"
                          :src="UserSelection.recommendProviderReference !== null && UserSelection.recommendProviderReference !== '' && UserSelection.recommendProviderReference === dataItem.Reference ? '/Images/selected.svg' : '/Images/unselected.svg'" />
                <el-image v-if="ChartType === 'Selectable' || ChartType === 'HighSelectable'" style="width:30px; margin-right:10px;" :src="dataItem.IsSelected ? '/Images/selected.svg' : dataItem.IsDisabled ? '/Images/disabledunselected.svg' : '/Images/unselected.svg'" />
                <el-image style="width: 56px; height: 61.25px; background:white;margin-right:10px;"
                          :src="dataItem.Logo"
                          fit="contain"></el-image>
                <div class="labels" style="display:inline-block; width:250px;">
                    <label class="headings">{{ dataItem.Label }}</label>
                </div>
                <div class="qualityScore">
                    <label class="headings" style="line-height: 32px; color: #0F172A;"> Quality score - {{dataItem.Value}}</label>
                    <div>
                        <!--<el-rate class="el-rate__icon" :max="4" style="font-size:30px;" v-model="dataItem.rating" :icon-classes="iconClasses" :colors="[ '#F56C6C', '#E6A23C','#67C23A' ]" void-color="#909399" disabled />-->
                        <svg style="width:100%" viewBox="0 0 275 10">
                            <rect y="0"
                                  x="0"
                                  width="60"
                                  height="10"
                                  :fill="dataItem.Value > 0 ? dataItem.positiveFill : '#909399'" />
                            <rect y="0"
                                  x="75"
                                  width="60"
                                  height="10"
                                  :fill="(dataItem.Value >= 25.0 ? dataItem.positiveFill: '#909399')" />
                            <rect y="0"
                                  x="150"
                                  width="60"
                                  height="10"
                                  :fill="(dataItem.Value >= 50.0 ? dataItem.positiveFill: '#909399')" />
                            <rect y="0"
                                  x="225"
                                  width="60"
                                  height="10"
                                  :fill="(dataItem.Value >= 75.0 ? dataItem.positiveFill: '#909399')" />
                        </svg>
                    </div>
                </div>
                <div v-if="dataItem.DisplayValues.length > 1 && dataItem.DisplayValues[1].length > 0" class="price">
                    <label class="headings" style="line-height: 32px; width:100px;">Price </label>
                    <!-- <div class="cost" style="line-height: 41px;">
                        {{Selection.legacyPolicyProviderPrice <= 0 && dataItem.IsLegacy === true ? "£ -" : (dataItem.DisplayValues[1]) +
                        (UserSelection.underwritten && dataItem.DisplayValues[1] != dataItem.DisplayValues[3] ?
                            " to " + dataItem.DisplayValues[3] : "") }}
                    </div> -->
                    <div class="cost" style="line-height: 41px;">
                        {{Selection.legacyPolicyProviderPrice <= 0 && dataItem.IsLegacy === true ? "£ -" : (dataItem.DisplayValues[1]) }}
                    </div>
                </div>
                <div class="monthlyBenefit" v-if="AlternateValueTitle.length > 2 && AlternateValueTitle[2].join(' ') === 'Monthly Benefit'">
                    <label class="headings">Monthly benefit</label>
                    <div class="cost" style="line-height: 41px;">
                        {{dataItem.IsLegacy === true ? "Current policy" : dataItem.DisplayValues[2]}}
                    </div>
                </div>
                <div style="font-size: 12px; color: #1e228c;display: inline-block; text-align: right; margin-left: 25px; width: 150px;">
                    <div v-for="(altValue, titleIndex) in dataItem.DisplayValues"
                         :key="titleIndex + '-displayValues-' + dataItem.Reference">
                        <div v-if="altValue.BestQuality" style="display: inline-block; white-space: nowrap; background: #E7EAEE; padding: 4px; border-radius: 6px; margin-bottom: 2px; ">
                            <svg style="display:inline-block; height:10px; width:10px;" viewBox="0 0 100 100">
                                <path d="M 50.19041 4.1926253 L 61.078366 38.07943 C 61.104945 38.16215 61.18189 38.21825 61.26878 38.21825 L 96.50766 38.21825 C 96.61811 38.21825 96.70766 38.30779 96.70766 38.41825 C 96.70766 38.481894 96.67737 38.54174 96.62608 38.579423 L 68.11339 59.52824 C 68.04407 59.57917 68.01508 59.66871 68.04139 59.7506 L 78.93136 93.64366 C 78.96515 93.74883 78.90729 93.86147 78.80213 93.89526 C 78.74104 93.91489 78.67424 93.90401 78.62253 93.86602 L 50.11842 72.9235 C 50.04796 72.87173 49.95204 72.87173 49.88158 72.9235 L 21.377472 93.86602 C 21.288458 93.93142 21.16328 93.91228 21.09788 93.82326 C 21.059887 93.77155 21.049013 93.70475 21.06864 93.64366 L 31.95861 59.7506 C 31.98492 59.66871 31.955928 59.57917 31.886614 59.52824 L 3.373925 38.579423 C 3.2849107 38.514023 3.265768 38.388845 3.3311684 38.29983 C 3.368852 38.24854 3.4286976 38.21825 3.492343 38.21825 L 38.73122 38.21825 C 38.81811 38.21825 38.895055 38.16215 38.921634 38.07943 L 49.80959 4.1926253 C 49.843376 4.0874633 49.95602 4.029604 50.06118 4.063393 C 50.12257 4.0831183 50.17069 4.1312335 50.19041 4.1926253 Z" fill="#f19940" />
                            </svg>
                            Best Quality
                        </div>
                        <div v-if="altValue.BestInBudget" style="display: inline-block; white-space: nowrap; background: #E7EAEE; padding: 4px; border-radius: 6px; margin-bottom: 2px; ">
                            <svg style="display:inline-block; height:10px; width:10px;" viewBox="0 0 100 100">
                                <path d="M 35.6 29.4 C 35.6 29.4 19.6 11.8 29.6 12 C 39.6 12.2 45.2 14.8 49.6 14.4 C 54 14 70.013724 9.680275 73 9.6 C 75.98628 9.519726 78.38765 11.578045 76.2 18.6 C 74.01235 25.621956 72 28.4 65.2 29.4 C 58.4 30.4 59.4 28.2 48.8 28.2 C 38.2 28.2 35.6 29.4 35.6 29.4 Z" fill="#f19940" />
                                <path d="M 61.6 33.210008 C 70.88762 36.817825 80.1215 54.209774 83.2 66.6 C 86.2785 78.99023 85.3013 92.01954 75.35719 92.42518 C 65.413075 92.83081 59.6 90.4 49.2 90.6 C 38.8 90.8 38.42545 91.70508 28.557188 92.02518 C 18.688925 92.34528 14.305212 85.243 17.8 66.4 C 21.294788 47.557003 31.101304 35.865383 35.2 33.410008 C 39.298697 30.954633 52.31238 29.60219 61.6 33.210008 Z" fill="#f19940" />
                                <path d="M 51.87002 37.910863 L 57.056 54.051305 C 57.08258 54.134026 57.159526 54.190125 57.24641 54.190125 L 74.03333 54.190124 C 74.14378 54.190124 74.23333 54.27967 74.23333 54.390124 C 74.23333 54.45377 74.20303 54.513615 74.15174 54.5513 L 60.56701 64.532264 C 60.497695 64.58319 60.4687 64.67273 60.495014 64.75462 L 65.68301 80.90132 C 65.7168 81.00649 65.65894 81.11913 65.55378 81.15292 C 65.49269 81.172545 65.42589 81.16167 65.37418 81.12368 L 51.79802 71.149015 C 51.727564 71.09725 51.631646 71.09725 51.56119 71.149015 L 37.98503 81.12368 C 37.896016 81.18908 37.77084 81.16994 37.70544 81.08092 C 37.667446 81.02921 37.65657 80.96241 37.6762 80.90132 L 42.864196 64.75462 C 42.890507 64.67273 42.861515 64.58319 42.7922 64.532264 L 29.207466 54.5513 C 29.118452 54.4859 29.09931 54.36072 29.16471 54.271706 C 29.202394 54.220416 29.26224 54.190124 29.325884 54.190124 L 46.112797 54.190125 C 46.199683 54.190125 46.27663 54.134026 46.30321 54.051305 L 51.48919 37.910863 C 51.52298 37.8057 51.635623 37.74784 51.740785 37.78163 C 51.80218 37.801356 51.85029 37.84947 51.87002 37.910863 Z" fill="black" />
                            </svg>
                            Best in budget
                        </div>

                        <div v-if="altValue.LowestPremium" style="display: inline-block; white-space: nowrap; background: #E7EAEE; padding: 4px; border-radius: 6px; margin-bottom: 2px; ">
                            <svg style="display:inline-block; height:10px; width:10px;" viewBox="0 0 100 100">
                                <path d="M 28.926708 45.757453 L 8.4 45.757453 L 50 90.45807 L 91.6 45.757453 L 71.07329 45.757453 L 71.07329 9.541926 L 28.926708 9.541926 Z" fill="#01ebff" />
                            </svg>
                            Lowest premium
                        </div>
                        <div v-if="altValue.InBudget" style="display: inline-block; white-space: nowrap; background: #E7EAEE; padding: 4px; border-radius: 6px; margin-bottom: 2px; ">
                            <svg style="display:inline-block; height:10px; width:10px;" viewBox="0 0 100 100">
                                <path d="M 35.6 29.4 C 35.6 29.4 19.6 11.8 29.6 12 C 39.6 12.2 45.2 14.8 49.6 14.4 C 54 14 70.013724 9.680275 73 9.6 C 75.98628 9.519726 78.38765 11.578045 76.2 18.6 C 74.01235 25.621956 72 28.4 65.2 29.4 C 58.4 30.4 59.4 28.2 48.8 28.2 C 38.2 28.2 35.6 29.4 35.6 29.4 Z" fill="black" />

                                <path d="M 61.6 33.210008 C 70.88762 36.817825 80.1215 54.209774 83.2 66.6 C 86.2785 78.99023 85.3013 92.01954 75.35719 92.42518 C 65.413075 92.83081 59.6 90.4 49.2 90.6 C 38.8 90.8 38.42545 91.70508 28.557188 92.02518 C 18.688925 92.34528 14.305212 85.243 17.8 66.4 C 21.294788 47.557003 31.101304 35.865383 35.2 33.410008 C 39.298697 30.954633 52.31238 29.60219 61.6 33.210008 Z" fill="black" />
                            </svg>
                            In budget
                        </div>
                        <div v-if="altValue.IsLegacy" style="display: inline-block; white-space: nowrap; background: #E7EAEE; padding: 4px; border-radius: 6px; margin-bottom: 2px; ">
                            <svg class="icon icon-tabler icon-tabler-exclamation-mark" style="display:inline-block; height:10px; width:10px;" viewBox="0 0 24 24" stroke-width="5" stroke="red" fill="red" stroke-linecap="round" stroke-linejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M12 19v.01" />
                                <path d="M12 15v-10" />
                            </svg>
                            Current policy
                        </div>

                        <div v-if="altValue.Standard" style="display: inline-block; white-space: nowrap; background: #E7EAEE; padding: 4px; border-radius: 6px; margin-bottom: 2px; ">
                            <svg width="10px" height="10px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20.9752 12.1852L20.2361 12.0574L20.9752 12.1852ZM20.2696 16.265L19.5306 16.1371L20.2696 16.265ZM6.93777 20.4771L6.19056 20.5417L6.93777 20.4771ZM6.12561 11.0844L6.87282 11.0198L6.12561 11.0844ZM13.995 5.22142L14.7351 5.34269V5.34269L13.995 5.22142ZM13.3323 9.26598L14.0724 9.38725V9.38725L13.3323 9.26598ZM6.69814 9.67749L6.20855 9.10933H6.20855L6.69814 9.67749ZM8.13688 8.43769L8.62647 9.00585H8.62647L8.13688 8.43769ZM10.5181 4.78374L9.79208 4.59542L10.5181 4.78374ZM10.9938 2.94989L11.7197 3.13821V3.13821L10.9938 2.94989ZM12.6676 2.06435L12.4382 2.77841L12.4382 2.77841L12.6676 2.06435ZM12.8126 2.11093L13.042 1.39687L13.042 1.39687L12.8126 2.11093ZM9.86195 6.46262L10.5235 6.81599V6.81599L9.86195 6.46262ZM13.9047 3.24752L13.1787 3.43584V3.43584L13.9047 3.24752ZM11.6742 2.13239L11.3486 1.45675V1.45675L11.6742 2.13239ZM3.9716 21.4707L3.22439 21.5353L3.9716 21.4707ZM3 10.2342L3.74721 10.1696C3.71261 9.76945 3.36893 9.46758 2.96767 9.4849C2.5664 9.50221 2.25 9.83256 2.25 10.2342H3ZM20.2361 12.0574L19.5306 16.1371L21.0087 16.3928L21.7142 12.313L20.2361 12.0574ZM13.245 21.25H8.59635V22.75H13.245V21.25ZM7.68498 20.4125L6.87282 11.0198L5.3784 11.149L6.19056 20.5417L7.68498 20.4125ZM19.5306 16.1371C19.0238 19.0677 16.3813 21.25 13.245 21.25V22.75C17.0712 22.75 20.3708 20.081 21.0087 16.3928L19.5306 16.1371ZM13.2548 5.10015L12.5921 9.14472L14.0724 9.38725L14.7351 5.34269L13.2548 5.10015ZM7.18773 10.2456L8.62647 9.00585L7.64729 7.86954L6.20855 9.10933L7.18773 10.2456ZM11.244 4.97206L11.7197 3.13821L10.2678 2.76157L9.79208 4.59542L11.244 4.97206ZM12.4382 2.77841L12.5832 2.82498L13.042 1.39687L12.897 1.3503L12.4382 2.77841ZM10.5235 6.81599C10.8354 6.23198 11.0777 5.61339 11.244 4.97206L9.79208 4.59542C9.65573 5.12107 9.45699 5.62893 9.20042 6.10924L10.5235 6.81599ZM12.5832 2.82498C12.8896 2.92342 13.1072 3.16009 13.1787 3.43584L14.6307 3.05921C14.4252 2.26719 13.819 1.64648 13.042 1.39687L12.5832 2.82498ZM11.7197 3.13821C11.7548 3.0032 11.8523 2.87913 11.9998 2.80804L11.3486 1.45675C10.8166 1.71309 10.417 2.18627 10.2678 2.76157L11.7197 3.13821ZM11.9998 2.80804C12.1345 2.74311 12.2931 2.73181 12.4382 2.77841L12.897 1.3503C12.3873 1.18655 11.8312 1.2242 11.3486 1.45675L11.9998 2.80804ZM14.1537 10.9842H19.3348V9.4842H14.1537V10.9842ZM4.71881 21.4061L3.74721 10.1696L2.25279 10.2988L3.22439 21.5353L4.71881 21.4061ZM3.75 21.5127V10.2342H2.25V21.5127H3.75ZM3.22439 21.5353C3.2112 21.3828 3.33146 21.25 3.48671 21.25V22.75C4.21268 22.75 4.78122 22.1279 4.71881 21.4061L3.22439 21.5353ZM14.7351 5.34269C14.8596 4.58256 14.8241 3.80477 14.6307 3.0592L13.1787 3.43584C13.3197 3.97923 13.3456 4.54613 13.2548 5.10016L14.7351 5.34269ZM8.59635 21.25C8.12244 21.25 7.72601 20.887 7.68498 20.4125L6.19056 20.5417C6.29852 21.7902 7.3427 22.75 8.59635 22.75V21.25ZM8.62647 9.00585C9.30632 8.42 10.0392 7.72267 10.5235 6.81599L9.20042 6.10924C8.85404 6.75767 8.3025 7.30493 7.64729 7.86954L8.62647 9.00585ZM21.7142 12.313C21.9695 10.8365 20.8341 9.4842 19.3348 9.4842V10.9842C19.9014 10.9842 20.3332 11.4959 20.2361 12.0574L21.7142 12.313ZM3.48671 21.25C3.63292 21.25 3.75 21.3684 3.75 21.5127H2.25C2.25 22.1953 2.80289 22.75 3.48671 22.75V21.25ZM12.5921 9.14471C12.4344 10.1076 13.1766 10.9842 14.1537 10.9842V9.4842C14.1038 9.4842 14.0639 9.43901 14.0724 9.38725L12.5921 9.14471ZM6.87282 11.0198C6.8474 10.7258 6.96475 10.4378 7.18773 10.2456L6.20855 9.10933C5.62022 9.61631 5.31149 10.3753 5.3784 11.149L6.87282 11.0198Z" fill="#1e228c"/>
                            </svg>
                            Buy now
                        </div>
                        <div v-if="altValue.NonStandard" style="display: inline-block; white-space: nowrap; background: #E7EAEE; padding: 4px; border-radius: 6px; margin-bottom: 2px; ">
                            <el-icon><flag /></el-icon>
                            Buy now non-standard
                        </div>
                        <div v-if="altValue.Refer" style="display: inline-block; white-space: nowrap; background: #FF5050; padding: 4px; border-radius: 6px; margin-bottom: 2px; color: white;">
                            <svg width="10px" height="10px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15 6H9M20 21H19M19 21H5M19 21C19 18.4898 17.7877 16.1341 15.7451 14.675L12 12M5 21H4M5 21C5 18.4898 6.21228 16.1341 8.25493 14.675L12 12M20 3H19M19 3H5M19 3C19 5.51022 17.7877 7.86592 15.7451 9.32495L12 12M5 3H4M5 3C5 5.51022 6.21228 7.86592 8.25493 9.32495L12 12" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            Referred
                        </div>
                        <div v-if="altValue.EvidenceRequired" style="display: inline-block; white-space: nowrap; background: #FF5050 ; padding: 4px; border-radius: 6px; margin-bottom: 2px; color: white; ">
                            <svg width="10px" height="10px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15 6H9M20 21H19M19 21H5M19 21C19 18.4898 17.7877 16.1341 15.7451 14.675L12 12M5 21H4M5 21C5 18.4898 6.21228 16.1341 8.25493 14.675L12 12M20 3H19M19 3H5M19 3C19 5.51022 17.7877 7.86592 15.7451 9.32495L12 12M5 3H4M5 3C5 5.51022 6.21228 7.86592 8.25493 9.32495L12 12" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            Evidence Required
                        </div>
                        <div v-if="altValue.Decline" style="display: inline-block; white-space: nowrap; background: #FF5050; padding: 4px; border-radius: 6px; margin-bottom: 2px; color: white; ">
                            <svg width="10" height="10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20.9752 11.8148L20.2361 11.9426L20.9752 11.8148ZM20.2696 7.73505L19.5306 7.86285L20.2696 7.73505ZM6.93777 3.52293L6.19056 3.45832L6.93777 3.52293ZM6.12561 12.9156L6.87282 12.9802L6.12561 12.9156ZM13.995 18.7786L14.7351 18.6573V18.6573L13.995 18.7786ZM13.3323 14.734L14.0724 14.6128V14.6128L13.3323 14.734ZM6.69814 14.3225L6.20855 14.8907H6.20855L6.69814 14.3225ZM8.13688 15.5623L8.62647 14.9942H8.62647L8.13688 15.5623ZM10.5181 19.2163L9.79208 19.4046L10.5181 19.2163ZM10.9938 21.0501L11.7197 20.8618V20.8618L10.9938 21.0501ZM12.6676 21.9356L12.4382 21.2216L12.4382 21.2216L12.6676 21.9356ZM12.8126 21.8891L13.042 22.6031L13.042 22.6031L12.8126 21.8891ZM9.86195 17.5374L10.5235 17.184V17.184L9.86195 17.5374ZM13.9047 20.7525L13.1787 20.5642V20.5642L13.9047 20.7525ZM11.6742 21.8676L11.3486 22.5433V22.5433L11.6742 21.8676ZM3.9716 2.52928L3.22439 2.46467L3.9716 2.52928ZM3 13.7658L3.74721 13.8304C3.71261 14.2306 3.36893 14.5324 2.96767 14.5151C2.5664 14.4978 2.25 14.1674 2.25 13.7658H3ZM20.2361 11.9426L19.5306 7.86285L21.0087 7.60724L21.7142 11.687L20.2361 11.9426ZM13.245 2.75H8.59635V1.25H13.245V2.75ZM7.68498 3.58754L6.87282 12.9802L5.3784 12.851L6.19056 3.45832L7.68498 3.58754ZM19.5306 7.86285C19.0238 4.93226 16.3813 2.75 13.245 2.75V1.25C17.0712 1.25 20.3708 3.91895 21.0087 7.60724L19.5306 7.86285ZM13.2548 18.8998L12.5921 14.8553L14.0724 14.6128L14.7351 18.6573L13.2548 18.8998ZM7.18773 13.7544L8.62647 14.9942L7.64729 16.1305L6.20855 14.8907L7.18773 13.7544ZM11.244 19.0279L11.7197 20.8618L10.2678 21.2384L9.79208 19.4046L11.244 19.0279ZM12.4382 21.2216L12.5832 21.175L13.042 22.6031L12.897 22.6497L12.4382 21.2216ZM10.5235 17.184C10.8354 17.768 11.0777 18.3866 11.244 19.0279L9.79208 19.4046C9.65573 18.8789 9.45699 18.3711 9.20042 17.8908L10.5235 17.184ZM12.5832 21.175C12.8896 21.0766 13.1072 20.8399 13.1787 20.5642L14.6307 20.9408C14.4252 21.7328 13.819 22.3535 13.042 22.6031L12.5832 21.175ZM11.7197 20.8618C11.7548 20.9968 11.8523 21.1209 11.9998 21.192L11.3486 22.5433C10.8166 22.2869 10.417 21.8137 10.2678 21.2384L11.7197 20.8618ZM11.9998 21.192C12.1345 21.2569 12.2931 21.2682 12.4382 21.2216L12.897 22.6497C12.3873 22.8135 11.8312 22.7758 11.3486 22.5433L11.9998 21.192ZM14.1537 13.0158H19.3348V14.5158H14.1537V13.0158ZM4.71881 2.59389L3.74721 13.8304L2.25279 13.7012L3.22439 2.46467L4.71881 2.59389ZM3.75 2.48726V13.7658H2.25V2.48726H3.75ZM3.22439 2.46467C3.2112 2.61722 3.33146 2.75 3.48671 2.75V1.25C4.21268 1.25 4.78122 1.8721 4.71881 2.59389L3.22439 2.46467ZM14.7351 18.6573C14.8596 19.4174 14.8241 20.1952 14.6307 20.9408L13.1787 20.5642C13.3197 20.0208 13.3456 19.4539 13.2548 18.8998L14.7351 18.6573ZM8.59635 2.75C8.12244 2.75 7.72601 3.11302 7.68498 3.58754L6.19056 3.45832C6.29852 2.20975 7.3427 1.25 8.59635 1.25V2.75ZM8.62647 14.9942C9.30632 15.58 10.0392 16.2773 10.5235 17.184L9.20042 17.8908C8.85404 17.2423 8.3025 16.6951 7.64729 16.1305L8.62647 14.9942ZM21.7142 11.687C21.9695 13.1635 20.8341 14.5158 19.3348 14.5158V13.0158C19.9014 13.0158 20.3332 12.5041 20.2361 11.9426L21.7142 11.687ZM3.48671 2.75C3.63292 2.75 3.75 2.63156 3.75 2.48726H2.25C2.25 1.80474 2.80289 1.25 3.48671 1.25V2.75ZM12.5921 14.8553C12.4344 13.8924 13.1766 13.0158 14.1537 13.0158V14.5158C14.1038 14.5158 14.0639 14.561 14.0724 14.6128L12.5921 14.8553ZM6.87282 12.9802C6.8474 13.2742 6.96475 13.5622 7.18773 13.7544L6.20855 14.8907C5.62022 14.3837 5.31149 13.6247 5.3784 12.851L6.87282 12.9802Z" fill="#ffffff" />
                            </svg>
                            Can't offer cover
                        </div>
                        <div v-if="altValue.Postpone" style="display: inline-block; white-space: nowrap; background: #FF5050; padding: 4px; border-radius: 6px; margin-bottom: 2px; color: white;">
                            <svg width="10px" height="10px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15 6H9M20 21H19M19 21H5M19 21C19 18.4898 17.7877 16.1341 15.7451 14.675L12 12M5 21H4M5 21C5 18.4898 6.21228 16.1341 8.25493 14.675L12 12M20 3H19M19 3H5M19 3C19 5.51022 17.7877 7.86592 15.7451 9.32495L12 12M5 3H4M5 3C5 5.51022 6.21228 7.86592 8.25493 9.32495L12 12" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            Can't offer cover now
                        </div>
                        <div v-if="altValue.Exclusion" style="display: inline-block; white-space: nowrap; background: #FF5050; padding: 4px; border-radius: 6px; margin-bottom: 2px; color: white ">
                            <el-icon><warnTriangleFilled /></el-icon>
                            Exclusion
                        </div>
                        <!--<div v-if="altValue.BestQuality" style="margin-top:3px;">
                            <el-tag class="el-icon-star-off"> Best Quality</el-tag>
                        </div>
                        <div v-if="altValue.BestInBudget" style="margin-top:3px;">
                            <el-tag class="el-icon-star-off"> Best quality In Budget</el-tag>
                        </div>
                        <div v-if="altValue.InBudget" style="margin-top:3px;">
                            <el-tag class="el-icon-star-off"> In Budget</el-tag>
                        </div>
                        <div v-if="altValue.LowestPremium" style="margin-top:3px;">
                            <el-tag class="el-icon-arrow-down"> Lowest Premium</el-tag>
                        </div>-->
                    </div>
                </div>
            </div>
            <div v-if="ChartType!=='Selectable' && ChartType !== 'HighSelectable' && ChartType !== 'RecommendSelectable' && !UserSelection.underwritten" style="width:100%;text-align:right">
                <!-- <p style="font-size: small ;margin-top: 0.5rem; text-align:left" v-if="UserSelection.selectedCustomerType == '2' && dataItem.Customer"> {{ dataItem.Customer }} </p>    -->
                <el-collapse class="breakdownCollapse" title="View breakdown" accordion>
                    <el-collapse-item title="View breakdown">
                        <el-table :data="dataItem.tableData" stripe style="width: 100%" :show-header="false">
                            <el-table-column prop="category" style="width:50%" class="tabledata"></el-table-column>
                            <el-table-column prop="score" style="width:50%" class="tabledata"></el-table-column>
                        </el-table>
                    </el-collapse-item>
                </el-collapse>
            </div>
            <div v-else style="width:100%;">
                <!-- <p style="font-size: small ;margin-top: 0.5rem; text-align:left" v-if="UserSelection?.selectedCustomerType == '2' && dataItem.Customer"> {{ dataItem.Customer }} </p>     -->
                <el-collapse style="margin-top: 0.5rem; text-align:right" v-if="dataItem.IndicativeLoadingContributors != null" class="breakdownCollapse" title="Underwriting details" accordion>
                    <el-collapse-item title="Underwriting details">                        
                        <div style="text-align: left; margin-left: 10px;">
                            <p>
                                Download product documentation here:
                                <a style="margin-left: 2px" class="textColor" :href=dataItem.KeyFactsLink target="_blank"> Key Facts </a>
                                <a style="margin-left: 10px" class="textColor" :href=dataItem.TermsAndConditionsLink target="_blank"> Terms And Conditions </a>
                            </p>
                        </div>
                        <div class="grid">
                            <decisions-summary v-for=" decision in dataItem.IndicativeLoadingContributors" 
                                               :decision="decision"
                                               :key="decision.componentType" />
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </div>
        </div>
        <p style="text-align:right;">
            <!--<el-button type="success" v-if="ChartType==='Selected'" class="compare" @click="$emit('compare')">Compare providers</el-button>-->
            <el-button type="success"
                       v-if="ChartType==='Selected'"
                       class="compare"
                       :loading="IsComparing"
                       :disabled="IsComparing"
                       @click.stop="handleCompareClick">
                <template v-if="IsComparing">
                    Comparing&hellip;
                </template>
                <template v-else>
                    Compare providers
                </template>
            </el-button>
        </p>
    </div>
</template>
<style>
    .breakdownCollapse .el-collapse-item__header {
        line-height: 0px !important;
        height: 15px !important;
    }

    .breakdownCollapse .el-collapse-item__content {
        padding-bottom: 0;
    }

    .el-dialog__body {
        word-break: break-word !important;
    }
</style>
<style scoped>
    .el-button--success {
        background: #059669 !important;
        border-radius: 8px !important;
    }

        .el-button--success:hover {
            background: #059669 !important;
        }

        .el-button--success:focus {
            background: #059669 !important;
        }

    .breakdownCollapse {
        background: #F6F6F6 !important;
    }

    .Selection .breakdownCollapse {
        background: none !important;
    }

    .el-collapse-item__content {
        padding-bottom: 0px !important;
    }

    .el-table thead {
        display: none !important;
    }

    el-tag {
        background: #E7EAEE;
        border-radius: 8px;
        color: #1A1E7E;
        font-family: 'Inter';
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 14px;
    }

    .Selection {
        background: #E8EDFB !important;
        border: 1px solid #585BCA;
        border-radius: 8px;
        margin-bottom: 10px;
    }

        .Selection .card {
            background: none;
            border: none;
        }

    .userDetails {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 22px;
        color: #48494D;
    }

    .headings {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        display: flex;
        align-items: center;
        letter-spacing: -0.02em;
        color: #48494D;
    }

    .cost {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        display: flex;
        align-items: center;
        letter-spacing: -0.04em;
        color: #48494D;
    }

    .el-rate__icon {
        font-weight: bolder !important;
    }

    .el-collapse-item__header {
        background-color: #f6f6f6 !important;
        align-items: center;
        height: 20px;
        color: #303133;
        cursor: pointer;
        font-size: 13px;
        font-weight: 500;
        transition: border-bottom-color .3s;
        outline: 0;
    }

    .tabledata {
        width: 263px;
        height: 24px;
        left: 12px;
        top: 9.5px;
        font-family: 'Inter';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 24px;
        color: #48494D;
    }

    .el-table .el-table__cell {
        padding: 12px 0;
        min-width: 0;
        box-sizing: border-box;
        text-overflow: ellipsis;
        vertical-align: middle;
        position: relative;
        text-align: right;
    }

    .radioText {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 56px;
        display: flex;
        align-items: center;
        text-align: center;
        letter-spacing: -0.04em;
        color: #4B5768;
    }

    .monthlyBenefit {
        position: inherit;
        width: 100px;
        left: 422px;
        margin-left: 15px;
    }

    .price {
        position: inherit;
        width: 80px;
        left: 422px;
        margin-left: 15px;
    }

    .qualityScore {
        position: inherit;
        width: 150px;
        left: 200px;
        margin-left: 35px;
    }

    .links {
        text-decoration: underline;
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
    }

    .title {
        position: absolute;
        width: 317px;
        height: 34px;
        left: 150px;
        top: 89px;
        font-family: 'Inter';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 41px;
        display: flex;
        align-items: center;
        letter-spacing: -0.04em;
        color: #000000;
    }

    .results {
        position: absolute;
        width: 317px;
        height: 868px;
        left: 150px;
        top: 129px;
        background: #FFFFFF;
        border-radius: 8px;
    }

    .clientDetails {
        padding: 16px;
        position: static;
        width: 285px;
        height: 150px;
        left: 0px;
        top: 0px;
        background-color: #F7F8F9;
    }

    .labels {
        position: inherit;
        height: 80px;
        position: static;
        width: 150px;
        height: 28px;
        left: 0px;
        top: 0.5px;
        font-family: 'Inter';
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 19px;
        display: flex;
        align-items: center;
        color: #323A46;
    }

    .links {
        position: static;
        width: 109px;
        height: 28px;
        left: 176px;
        top: 0.5px;
        font-family: 'Inter';
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 41px;
        display: flex;
        align-items: center;
        text-align: right;
        letter-spacing: -0.04em;
        text-decoration-line: underline;
        color: #323A46;
        margin-left: 85px;
    }

    .detailsLabel {
        position: absolute;
        width: 129px;
        height: 26px;
        left: 16px;
        top: 49px;
        font-family: 'Inter';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 8px;
        display: flex;
        align-items: center;
        color: #A0ABBB;
    }

    .detailsList {
        position: absolute;
        width: 144px;
        height: 26px;
        left: 157px;
        top: 49px;
        font-family: 'Inter';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 8px;
        /* or 57% */
        display: flex;
        align-items: center;
        /* Neutral/700 */
        color: #323A46;
        margin-left: 12px
    }

    .customizeResult {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 15px;
        position: static;
        width: 285px;
        height: 146px;
        left: 16px;
        top: 197px;
    }

    .clientBudget {
        position: static;
        width: 280px;
        height: 107px;
        left: 0px;
        top: 39px;
    }

    .el-input {
        position: absolute;
        width: 280px;
        height: 44px;
        left: 20px;
        background: #FFFFFF;
    }

    .el-checkbox__inner {
        width: 27px;
        height: 28px;
        border-radius: 4px;
        display: inline-block;
        position: relative;
        border: 1px solid #dcdfe6;
        box-sizing: border-box;
        background-color: #fff;
        z-index: 1;
        transition: border-color .25s cubic-bezier(.71, -.46, .29, 1.46),background-color .25s cubic-bezier(.71, -.46, .29, 1.46);
    }

    .checkboxLabel {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 8px;
        align-items: center;
        color: #323A46;
        padding-left: 10px;
        left: 10px;
    }

    .premiumTypeDetails {
        position: static;
        width: 285px;
        height: 173px;
        left: 16px;
        top: 100px;
        padding: 15px;
    }

    .navigationbtn {
        margin-top: 50px;
        padding: 16px;
    }

    .el-checkbox__input.is-checked + .el-checkbox__label {
        color: #323A46;
    }


    .el-button--default {
        color: black;
        background-color: white;
        border: 1px solid #191D23;
    }

        .el-button--default:focus, .el-button--default:hover {
            background: white;
            border-radius: 8px;
            border: 1px solid #191D23;
            border-radius: 8px;
            color: black;
        }

    .btn {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 10px;
        position: absolute;
        height: 40px;
        left: 297px;
        top: 0px;
        /* Primary/600 */
    }



    .right {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 16px;
        position: absolute;
        width: 807px;
        /*height: 618px;*/
        left: 486px;
        top: 123px;
        background: #FFFFFF;
        border-radius: 8px;
    }

    .count {
        position: static;
        width: 287px;
        height: 40px;
        left: 0px;
        top: 0px;
        font-family: 'Inter';
        font-style: normal;
        font-weight: 600;
        font-size: 21px;
        line-height: 41px;
        /* or 195% */
        display: flex;
        align-items: center;
        letter-spacing: -0.04em;
        /* Neutral / Gray 900 */
        color: #0F172A;
    }


    .card {
        padding: 8px;
        background: #F6F6F6;
        border-radius: 8px;
    }

    .logo {
        position: absolute;
        width: 56px;
        height: 61.25px;
        background: url('https://logo.clearbit.com/spotify.com');
    }

    .text {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 22px;
        color: #48494D;
    }

    .analysisbottomMargin50 {
        width: 100% !important;
    }

    .bottomHugging {
        position: sticky;
        bottom: 60px;
        height: 50px;
        background-color: rgba(30, 34, 140, 0.5);
        padding-top: 10px;
    }

    .compare {
        margin-right: 10px;
        width: 155px;
        height: 40px;
        font-family: 'Inter';
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        align-items: center;
        text-align: center;
        letter-spacing: -0.04em;
        color: #FFFFFF;
        background: #059669;
        border-radius: 8px;
    }

        .compare:hover {
            background: #059669;
            border-radius: 8px;
        }



    .chartDiv {
        padding-left: 330px;
        min-width: auto;
        display: block
    }

        .chartDiv div, .chartDiv div div {
            display: block;
            min-width: auto;
        }

    #Quality + label {
        border-bottom-right-radius: 0 !important;
        border-top-right-radius: 0 !important;
    }

    #Pricing + label {
        border-bottom-left-radius: 0 !important;
        border-top-left-radius: 0 !important;
    }

    fieldset {
        text-align: center;
        margin-left: auto;
        width: 425px;
        margin-right: auto;
    }

        fieldset.customise {
            text-align: left;
            border: 3px solid #1e228c;
            padding: 0 0 0 10px;
            width: 300px;
            float: left;
            position: sticky;
            top: 0;
        }

            fieldset.customise legend {
                padding: 5px 5px 5px 5px;
                float: left;
            }

            fieldset.customise h3 {
                padding: 5px 5px 5px 5px;
                clear: both;
                color: #1e228c;
                font-weight: normal;
                border-top: 1px solid #1e228c;
            }

    .budget {
        display: block;
        border: solid 1px #1e228c;
        margin: 5px 5px 5px 5px;
        position: relative;
        padding-left: 25px;
    }

        .budget::before {
            content: "�";
            width: 10px;
            font-family: 'Roboto';
            color: #1e228c;
            display: inline-block;
            padding-left: 5px;
            font-size: 24px;
            text-align: left;
            position: absolute;
            left: 0px;
        }

        .budget input {
            border: none;
            font-size: 24px;
            padding: 0px 0px 0px 0px;
            display: block;
            width: 100%;
        }

    .grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: repeat(auto, 1fr);
        grid-column-gap: 50px;
        grid-row-gap: 20px;
        text-align: left;
        margin-left: 10px;
    }
</style>

<script>
    import helper from './HelperMethods.vue';
    import { ElIcon } from 'element-plus';
    import { Flag, WarnTriangleFilled } from '@element-plus/icons-vue';
    import DecisionsSummary from './DecisionsSummary.vue';
    export default {
        name: 'BarChart',
        props: ["chartData", "expandedKeys", "alternateValueTitle", "chartTitle", "maxSelection", "selection", "userSelection", "analysis", "chartType", "isComparing"],
        data: function () {
            return {
                CheckboxSize: 20,
                CheckboxLineWidth: 2.5,
                DataTableColumnWidth: 50,
                Markings: ['0', '25', '50', '75', '100'],
                ChartWidth: 500.0,
                BarHeight: 10.0,
                GapBetweenTextAndBar: 2.0,
                TextHeight: 10.0,
                ProviderLegendFontSize: 12,
                ScoreLegendFontSize: 11,
                ValueFontSize: 11,
                BarArea: 33.0,
                LeftArea: 25.0,
                //TopArea: 50.0,
                //RightArea: 100.0,
                TextGap: 5.0,
                TitleFontSize: 16,
                CompareFontSize: 14,
                DataTableColumnGap: 1,
                ratings: 4,
                activeNames: [''],
                value: null,
                iconClasses: ['el-icon-minus', 'el-icon-minus', 'el-icon-minus'],
                customOrder: ["LIFE", "ALTLIFE", "CI", "ALTCI", "TPD", "WOP"],

            }
        },
        components: {
            ElIcon,
            Flag,
            WarnTriangleFilled,
            DecisionsSummary,
        },
        methods: {
            IsSelected: function (reference) {
                return this.Selection.indexOf(reference) >= 0;
            },
            GetColor: function (dataItem, index) {
                if (dataItem.Color !== null && dataItem.Color !== "" && typeof (dataItem.Color) !== "undefined")
                    return dataItem.Color;
                return helper.standardChartColors[index % helper.standardChartColors.length]
            },
            Select: function (reference) {
                /*if (this.ChartType !== 'Selectable')
                    return;
                    */
                if (this.IsSelected(reference)) {
                    //log
                    var index = this.Selection.indexOf(reference);
                    if (index > -1) {
                        this.Selection.splice(index, 1);
                    }

                }
                else if (this.CanAddExtra)
                    this.Selection.push(reference);
            },
            Toggle: function (dataItem) {
                if (!dataItem.IsDisabled)
                    if (this.ExpandedKeys.keys.some(function (k) { return k === dataItem.Reference; })) {
                        this.ExpandedKeys.keys = this.ExpandedKeys.keys.filter(function (k) { return k !== dataItem.Reference; });
                    }
                    else {
                        this.ExpandedKeys.keys.push(dataItem.Reference);
                    }
            },
            Round: function (value) {
                return parseFloat(value).toFixed(1);
            },
            RecommandSelect: function (reference) {
                this.UserSelection.recommendProviderReference = "";
                this.UserSelection.recommendProviderReference = reference;
            },
            handleCompareClick: function () {
                if (this.IsComparing) {
                    return;
                }
                this.$emit('compare');
            }
        },
        created: function () {
            console.log(this.Selection);
        },
        computed: {
            ChartData: function () { return this.chartData; },
            ExpandedKeys: function () { return this.expandedKeys; },
            AlternateValueTitle: function () { return this.alternateValueTitle; },
            MaxSelection: function () { return this.maxSelection; },
            Selection: function () { return this.selection; },
            ChartTitle: function () { return this.chartTitle; },
            UserSelection: function () { return this.userSelection; },
            Analysis: function () { return this.analysis; },
            ChartType: function () { return this.chartType; },
            IsComparing: function () { return this.isComparing === true; },
            CanAddExtra: function () {
                return this.MaxSelection > this.Selection.length;
            },
            HasSelected: function () {
                var thisControl = this;
                return this.DisplayItems.some(function (di) { return thisControl.Selection.some(function (s) { return di.Reference === s; }) })
            },
            RightArea: function () {
                if (this.AlternateValueTitle === null) {
                    return 100;
                }

                return 10 + (this.AlternateValueTitle.length) * (this.DataTableColumnWidth + this.DataTableColumnGap);
            },
            TopArea: function () {
                return this.Title === null ? 40 : 40;
            },
            DisplayItems: function () {
                var result = [];
                if (this.ChartData != null) {
                    for (var g = 0; g < this.ChartData.items.length; g++) {
                        var group = this.ChartData.items[g];

                        //var isExpanded = this.ExpandedKeys.keys.some(function (k) { return k === group.key; }) || this.ordering === 'Individual_product_premium';
                        var isExpanded = this.ExpandedKeys.keys.some(function (k) { return k === group.key; });

                        if (group.values.length > 1) {
                            var firstValue = group.values[0].Value;
                            var lastValue = group.values[group.values.length - 1].Value;
                            var firstItem = group.values[0];
                            var lastItem = group.values[group.values.length - 1];
                            var display = firstValue;

                            if (firstValue < lastValue) {
                                display = firstItem.DisplayValue + " \u21D2 " + lastItem.DisplayValue;
                            }
                            else if (firstValue > lastValue) {
                                display = lastItem.DisplayValue + " \u21D4 " + firstItem.DisplayValue;
                            }
                            var minValue = Math.min(firstValue, lastValue);
                            var maxValue = Math.max(firstValue, lastValue);

                            result.push({
                                Value: minValue,
                                Value2: maxValue,
                                Label: group.key + "\t" + group.values.length + " options avaiable ranging from " + display,
                                DisplayValue: '' /*display*/,
                                AlternateDisplayValue: '',
                                Color: group.values[0].Color !== undefined && group.values[0].Color !== null ? group.values[0].Color : '',
                                Logo: group.values[0].Logo,
                                Reference: group.key,
                                Group: group.key,
                                positiveFill: minValue > 50 ? '#67C23A' : minValue > 25.0 ? '#E6A23C' : '#F56C6C',
                                Tooltip: false,
                                IsExpanded: isExpanded,
                                HasTooltip: false,
                                tableData: group.values[0].tableData,
                                IsSelected: this.Selection.indexOf(group.key) >= 0,
                                IsDisabled: this.Selection.indexOf(group.values[0].key) < 0 && this.Selection.length >= this.MaxSelection,
                                IsLegacy: group.IsLegacym,
                                IndicativeLoadingContributors: '',
                                KeyFactsLink: '',
                                TermsAndConditionsLink: '',
                                // Customer: '',
                            });
                        }
                        if (isExpanded || group.values.length === 1) {
                            for (var i = 0; i < group.values.length; i++) {
                                result.push({
                                    Value: group.values[i].Value,
                                    Value2: group.values[i].Value,
                                    Label: group.values[i].Label,
                                    DisplayValue: group.values[i].DisplayValue,
                                    DisplayValues: group.values[i].DisplayValues,
                                    Logo: group.values[i].Logo,
                                    AlternateDisplayValue: group.values[i].AlternateDisplayValue,
                                    Color: group.values[i].Color !== undefined && group.values[i].Color !== null ? group.values[i].Color : '',
                                    Reference: group.values[i].Reference,
                                    positiveFill: group.values[i].Value > 50 ? '#67C23A' : group.values[i].Value > 25.0 ? '#E6A23C' : '#F56C6C',
                                    Group: group.key,
                                    Tooltip: group.values[i].Tooltip,
                                    HasTooltip: group.values[i].HasTooltip,
                                    IsExpanded: null,// (i === 0 && group.values.length > 1) ? true : null
                                    datatableBoxColor: group.values[i].datatableBoxColor,
                                    outlineBoxColor: group.values[i].outlineBoxColor,
                                    rating: group.values[i].Value > 75.0 ? 4 : group.values[i].Value > 50.0 ? 3 : group.values[i].Value > 25.0 ? 2.0 : group.values[i].Value > 0.0 ? 1.0 : 0,
                                    tableData: group.values[i].tableData,
                                    IsSelected: this.Selection.indexOf(group.values[i].Reference) >= 0,
                                    IsDisabled: this.Selection.indexOf(group.values[i].key) < 0 && this.Selection.length >= this.MaxSelection,
                                    IsLegacy: group.IsLegacy,
                                    IndicativeLoadingContributors: group.values[i].IndicativeLoadingContributors?.sort((a, b) => {
                                        const indexA = this.customOrder.indexOf(a.componentType);
                                        const indexB = this.customOrder.indexOf(b.componentType);
                                        return indexA - indexB;
                                    }),
                                    DecisionType: group.values[i].DecisionType,
                                    KeyFactsLink: group.values[i].KeyFactsLink,
                                    TermsAndConditionsLink: group.values[i].TermsAndConditionsLink,
                                    // Customer: group.values[i].Customer,
                                });
                            }
                        }
                    }
                }
                return result;
            }
        },
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
